export const USER_JWT_TOKEN = "shipraUserJwtToken";
export const USER_DATA = "userData";
export const USER_ACCESS_PATH = "userAccessPath";
